export var ifftDocs = {
  name: 'ifft',
  category: 'Matrix',
  syntax: ['ifft(x)'],
  description: 'Calculate N-dimensional inverse fourier transform',
  examples: ['ifft([[2, 2], [0, 0]])'],
  seealso: ['fft']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/expression/embeddedDocs/function/matrix/ifft.js
// module id = 8ZGu
// module chunks = 3